let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("88IHv")).then(() => parcelRequire('3Ia9r'));